import React from 'react';
import { Alert, Box, Paper, Stack, Typography } from '@mui/material';
import { formatAppDate } from '../../utils/dateFormat';
import PageHeader from '../../components/PageHeader';
import { useAuth } from '../../contexts/AuthContext';

const ClientHomePage: React.FC = () => {
  const { user } = useAuth();
  const tariffName = user?.tariff === 'BUSINESS' ? 'Бизнес' : 'Старт';
  const subscriptionActive = user?.subscriptionActive !== false;

  return (
    <Box>
      <PageHeader
        title="Главная"
        description="Добро пожаловать в кабинет ТрендиОРД"
      />
      <Stack spacing={2}>
        <Paper sx={{ p: 2.5 }}>
          <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
            {user?.ordClientName || 'Ваш кабинет'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Тариф «{tariffName}». Создавайте контрагентов, договоры и креативы — система поможет сдать статистику в ОРД.
          </Typography>
          <Stack spacing={0.5}>
            <Typography variant="body2">
              Подписка: {subscriptionActive ? 'активна' : 'неактивна'}
            </Typography>
            {user?.subscriptionPaidUntil && (
              <Typography variant="body2">
                Оплачено до: {formatAppDate(user.subscriptionPaidUntil)}
              </Typography>
            )}
          </Stack>
        </Paper>
        {!subscriptionActive && (
          <Alert severity="warning">
            Срок подписки истёк. Обратитесь к администратору Тренди для продления.
          </Alert>
        )}
        <Paper sx={{ p: 2 }}>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>С чего начать</Typography>
          <Typography variant="body2" component="ol" sx={{ pl: 2, m: 0 }}>
            <li>Добавьте контрагента (рекламодателя или издателя)</li>
            <li>Создайте договор</li>
            <li>Создайте креатив и отправьте в ОРД</li>
            <li>После публикации привяжите ссылки на ролики</li>
          </Typography>
        </Paper>
      </Stack>
    </Box>
  );
};

export default ClientHomePage;
